import React from "react";
import UserAvatar from "../atoms/UserAvatar";
import { INK, INK_2, INK_3, BURGUNDY, BURGUNDY_TINT, LINE } from "../../Bureau/bureauTokens";

function formatPreviewTime(date) {
  if (!date) return "";
  const d = new Date(date);
  return isNaN(d) ? "" : d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" });
}

function lastMessagePreview(lastMessage) {
  if (!lastMessage) return "Nouvelle conversation";
  if (lastMessage.body) return lastMessage.body;
  if (lastMessage.attachmentType?.startsWith("image/")) return "📎 Image";
  if (lastMessage.attachmentUrl) return "📎 Fichier";
  return "";
}

function ThreadListItem({ otherUser, lastMessage, unreadCount, updatedAt, active, onClick }) {
  const name = otherUser ? `${otherUser.name || ""} ${otherUser.lastName || ""}`.trim() : "Collaborateur";
  const unread = unreadCount > 0;

  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-2.5 text-left px-3 py-2.5"
      style={{ borderRadius: 10, background: active ? BURGUNDY_TINT : "transparent", borderBottom: `1px solid ${LINE}` }}
    >
      <UserAvatar name={otherUser?.name} lastName={otherUser?.lastName} picture={otherUser?.picture} size={38} />
      <span className="flex-1 min-w-0 flex flex-col gap-0.5">
        <span className="flex items-center justify-between gap-2">
          <span className="text-[12px] truncate" style={{ color: unread ? BURGUNDY : INK, fontWeight: unread ? 700 : 600 }}>
            {name}
          </span>
          <span className="text-[10px] flex-shrink-0" style={{ color: INK_3 }}>
            {formatPreviewTime(updatedAt)}
          </span>
        </span>
        <span className="flex items-center justify-between gap-2">
          <span className="text-[11px] truncate" style={{ color: unread ? INK_2 : INK_3, fontWeight: unread ? 600 : 400 }}>
            {lastMessagePreview(lastMessage)}
          </span>
          {unread && (
            <span
              className="flex-shrink-0 flex items-center justify-center text-[10px] font-bold text-white"
              style={{ minWidth: 18, height: 18, borderRadius: 999, background: BURGUNDY, padding: "0 5px" }}
            >
              {unreadCount}
            </span>
          )}
        </span>
      </span>
    </button>
  );
}

export default ThreadListItem;
